export default {"src":"/_next/static/media/empty-cms-page.8055a177.svg","height":155,"width":211,"blurWidth":0,"blurHeight":0};